/* import __COLOCATED_TEMPLATE__ from './weekly-events.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { DateTime } from 'luxon';
let WeeklyEvents = (_class = class WeeklyEvents extends Component {
  get weeksInYear() {
    const {
      weeksInWeekYear
    } = DateTime.fromObject({
      year: this.args.year
    });
    const weeks = [];
    for (let i = 1; i <= weeksInWeekYear; i++) {
      weeks.push(`${i}`);
    }
    return weeks;
  }
  get weekInFocus() {
    return this.args.weekInFocus || '';
  }
  incrementYear() {
    this.args.setYear(parseInt(this.args.year, 10) + 1);
  }
  decrementYear() {
    this.args.setYear(parseInt(this.args.year, 10) - 1);
  }
}, _applyDecoratedDescriptor(_class.prototype, "incrementYear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementYear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementYear"), _class.prototype), _class);
export { WeeklyEvents as default };